<script setup>
import CFTicketModalInner from '#modules/support/components/Ticket/CFTicketModalInner.vue';
import CFButton from '@/ui/Button/CFButton.vue';
import { useTicketStore } from '#modules/support/stores/ticket.store.js';
import CreateTicketStep from '#modules/support/components/Ticket/Steps/CreateTicketStep.vue';
import ProductSelectStep from '#modules/support/components/Ticket/Steps/ProductSelectStep.vue';
import CFCircleBackButton from '@/shared/components/CFCircleBackButton.vue';
import SelectSSLStep from '#modules/support/components/Ticket/Steps/SelectSSLStep.vue';
import CFTicketSelectProductsWrapper from '#modules/support/components/Ticket/CFTicketSelectProductsWrapper.vue';
import CFTicketSSLItem from '#modules/support/components/Ticket/CFTicketSSLItem.vue';
import { shallowRef } from 'vue';

const ticketStore = useTicketStore();

const selectedCertificate = shallowRef(null);

const setSelectedCertificate = (certificate, callback) => {
    selectedCertificate.value = certificate;
    callback(certificate);
};

const goToCreateTicketStep = () => {
    ticketStore.setComponent(CreateTicketStep, SelectSSLStep, {
        ssl: selectedCertificate,
    });
};
</script>

<template>
    <CFTicketModalInner :title="$t('support.select_product')">
        <CFTicketSelectProductsWrapper
            :search-placeholder="$t('general.search_for_ssl_certificate')"
            route="general/ssl-certificates"
        >
            <template #item="{ item, selectedItem, onSelect }">
                <CFTicketSSLItem
                    :certificate="item"
                    :selected-certificate="selectedItem"
                    @select="setSelectedCertificate(item, onSelect)"
                />
            </template>
        </CFTicketSelectProductsWrapper>

        <template #actions>
            <CFCircleBackButton @click="ticketStore.goToPrevious(ProductSelectStep)">
                {{ $t('button.back') }}
            </CFCircleBackButton>

            <CFButton
                type="button"
                :disabled="!selectedCertificate"
                @click="goToCreateTicketStep"
            >
                {{ $t('button.next') }}
            </CFButton>
        </template>
    </CFTicketModalInner>
</template>
